import React, { useRef, useState, useEffect } from 'react';
import commonUtil from '../../../../utils/commonUtil';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import EventIcon from '../../../../components/EventIcon/EventIcon';
import { constEventStatus } from '../../../../utils/clientConstant';
import { connect } from 'react-redux';

const channel = commonUtil.getChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

const UserEventsCardList = (props) => {
  const eventsList =
    props?.eventsList || props?.state?.eventDetail?.data?.eventList || [];
  const carouselRef = useRef(null);
  const [showArrows, setShowArrows] = useState({ left: false, right: false });

  const convertSpanishToEnglishChars = (str) => {
    const normalizedStr = str.normalize('NFD');
    const withoutDiacritics = normalizedStr.replace(/[\u0300-\u036f]/g, '');
    const finalStr = withoutDiacritics.replace(/ñ/g, 'n').replace(/Ñ/g, 'N');
    return finalStr;
  };

  const goToGiftListClickEvent = (eventID) => {
    if (browserHistory) {
      const route = commonUtil.routeTo(applicationRoutes.giftList, {
        eventID: eventID,
      });
      if (route) {
        browserHistory.push(route);
      }
    }
  };

  const getStatus = (detail) => {
    let contentStackStatus = detail?.eventStatus?.replace(' ', '_') || '';
    let status = commonUtil.getLabel(
      props?.state?.labels?.data?.home,
      'home.statusmsg.' + contentStackStatus,
    );
    return detail?.eventStatus == constEventStatus.ACTIVE
      ? detail && detail?.noOfDays
        ? detail?.noOfDays + ' ' + 'días para tu evento'
        : status
      : '';
  };

  // Handle scroll logic
  const handleScroll = (direction) => {
    if (!carouselRef.current) return;
    const cardWidth =
      carouselRef.current.querySelector('.multiple-card')?.offsetWidth ||
      (channel === 'wap' ? 140 : 240);
    const gap = 24;
    const scrollAmount = cardWidth + gap;
    carouselRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  const eventStatusTitle = (detail) => {
    const eventStatus = detail?.eventStatus || '';

    let eventTitle = '';

    if (eventStatus == constEventStatus.CLOSED) {
      eventTitle = commonUtil.getLabel(
        props?.labels?.homePage,
        'eventcard.status.closed',
      );
    }

    if (eventStatus == constEventStatus.SUSPENDED) {
      eventTitle = commonUtil.getLabel(
        props?.labels?.homePage,
        'eventcard.status.suspended',
      );
    }

    if (eventStatus == constEventStatus.ADMINPROCESS) {
      eventTitle = commonUtil.getLabel(
        props?.labels?.homePage,
        'eventcard.status.adminstration.process',
      );
    }

    if (eventStatus == constEventStatus.TEMPORARYCLOSED) {
      eventTitle = commonUtil.getLabel(
        props?.labels?.homePage,
        'eventcard.status.temporarely.closed',
      );
    }

    if (
      !(
        eventStatus == constEventStatus.CLOSED ||
        eventStatus == constEventStatus.SUSPENDED ||
        eventStatus == constEventStatus.TEMPORARYCLOSED ||
        eventStatus == constEventStatus.UNDER_REVIEW
      )
    ) {
      return '';
    }

    return eventTitle;
  };

  // Check for overflow to toggle arrow visibility
  useEffect(() => {
    const checkOverflow = () => {
      if (!carouselRef.current) return;
      const { scrollWidth, clientWidth, scrollLeft } = carouselRef.current;
      console.log('checkOverflow:', { scrollLeft, scrollWidth, clientWidth }); // Debug log
      setShowArrows({
        left: scrollLeft > 0,
        right: scrollWidth > clientWidth + scrollLeft + 1,
      });
    };

    // Reset scroll position and check overflow
    const initializeScroll = () => {
      if (carouselRef.current) {
        carouselRef.current.scrollLeft = 0;
        checkOverflow();
      }
    };

    // Wait for images to load and force layout recalculation
    const images = carouselRef.current?.querySelectorAll('img') || [];
    let loadedImages = 0;
    const totalImages = images.length;

    const handleImageLoad = () => {
      loadedImages += 1;
      if (loadedImages === totalImages || totalImages === 0) {
        // Force layout recalculation
        requestAnimationFrame(() => {
          requestAnimationFrame(initializeScroll);
        });
      }
    };

    if (totalImages > 0) {
      images.forEach((img) => {
        if (img.complete) {
          handleImageLoad();
        } else {
          img.addEventListener('load', handleImageLoad);
          img.addEventListener('error', handleImageLoad); // Handle failed images
        }
      });
    } else {
      // No images, use timeout as fallback
      const timeoutId = setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(initializeScroll);
        });
      }, 100); // 100ms delay to allow layout
      return () => clearTimeout(timeoutId);
    }

    // Additional fallback with ResizeObserver
    const resizeObserver = new ResizeObserver(checkOverflow);
    if (carouselRef.current) {
      resizeObserver.observe(carouselRef.current);
    }

    window.addEventListener('resize', checkOverflow);
    const carousel = carouselRef.current;
    if (carousel) carousel.addEventListener('scroll', checkOverflow);

    return () => {
      if (carouselRef.current) resizeObserver.unobserve(carouselRef.current);
      window.removeEventListener('resize', checkOverflow);
      if (carousel) carousel.removeEventListener('scroll', checkOverflow);
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
        img.removeEventListener('error', handleImageLoad);
      });
    };
  }, [eventsList]);

  return eventsList?.length < 1 ? (
    <></>
  ) : (
    <div className='container-column'>
      <div className='header-row'>
        <p className='header-text'>Tus mesas de regalos</p>
      </div>
      <div className='events-caurosel-container'>
        {eventsList.length > 1 && (
          <>
            <button
              className={`carousel-arrow left ${showArrows.left ? 'visible' : ''}`}
              onClick={() => handleScroll('left')}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height='32px'
                viewBox='0 -960 960 960'
                width='32px'
                fill='#434343'
              >
                <path d='M576-240 336-480l240-240 51 51-189 189 189 189-51 51Z'></path>
              </svg>
            </button>
            <button
              className={`carousel-arrow right ${showArrows.right ? 'visible' : ''}`}
              onClick={() => handleScroll('right')}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height='32px'
                viewBox='0 -960 960 960'
                width='32px'
                fill='#434343'
              >
                <path d='M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z'></path>
              </svg>
            </button>
          </>
        )}
        <div
          id='event-cards'
          className={` ${
            eventsList.length > 1 ? 'multiple-card-wrapper' : 'card-wrapper'
          }`}
          // style={eventsList.length > 1 ? { display: 'none' } : null}
        >
          <div className='carousel-content' ref={carouselRef}>
            <div
              className={`${
                eventsList.length > 1 ? 'multiple-card-row' : 'card-row'
              }`}
            >
              {eventsList?.map((detail , index , eventsListArr) => {
                {
                  detail?.eventImage;
                  let eventData =
                    _.find(
                      props?.state?.eventcategory?.data?.eventConfigurations,
                      ['name', detail?.eventType],
                    ) || {};
                  let themeData =
                    _.find(eventData?.event_themes, [
                      'uid',
                      detail?.eventTheme,
                    ]) || {};

                  let eventImage = detail?.eventImage;
                  const imageFormat =
                    commonUtil.checkImageURLFormat(eventImage);
                  const isSingleCard = eventsListArr.length === 1;
                  const iconWapHeight = isSingleCard ? '9rem' : '120px';
                  const iconWapWidth = isSingleCard ? '9rem' : '120px';
                  const eventStatus = getStatus(detail);

                  return (
                    <div
                      key={detail.eventId}
                      className={`${
                        eventsList.length > 1 ? 'multiple-card' : 'card'
                      }`}
                      onClick={() => goToGiftListClickEvent(detail.eventId)}
                    >
                      <EventIcon
                        event_id={detail?.eventId}
                        event_icon={eventData?.event_icon}
                        event_theme_color={themeData?.color_500 || ' #000'}
                        event_image={!imageFormat ? eventImage : null}
                        multiple={eventsList.length > 1 && channel == 'wap'}
                        icon_height={channel == 'wap' ? iconWapHeight : '150px'}
                        icon_width={channel == 'wap' ? iconWapWidth : '150px'}
                      />
                      <div
                        className={`${
                          eventsList.length > 1
                            ? 'multiple-card-content'
                            : 'card-content'
                        }`}
                      >
                        <p
                          style={{
                            color: themeData?.color_500 || detail.color,
                          }}
                          className={`${
                            eventsList.length > 1 ? 'multiple-title' : 'title'
                          }`}
                        >
                          {detail?.eventName}
                        </p>
                        <div
                          className={`${
                            eventsList.length > 1
                              ? 'multiple-type-row'
                              : 'type-row'
                          }`}
                        >
                          <div className='type-icon-wrapper'>
                            <img
                              className='type-icon'
                              style={{
                                maskImage: `url('/assets/common/images/svgs/${encodeURIComponent(
                                  convertSpanishToEnglishChars(
                                    eventData?.eventDisplayName ||
                                      detail?.eventType,
                                  ),
                                )}.svg')`,
                                backgroundColor: themeData?.color_500 || '#000',
                              }}
                              alt=''
                            />
                          </div>
                          <p
                            style={{ color: detail.color }}
                            className='type-text'
                          >
                            {eventData?.eventDisplayName || detail?.eventType}
                          </p>
                        </div>
                       {eventStatus && <p
                          style={{ color: detail.color }}
                          className={`${
                            eventsList.length > 1
                              ? 'multiple-countdown'
                              : 'countdown'
                          }`}
                        >               
                              {eventStatus}
                        </p>}
                        <p className='event-status-title'>
                          {eventStatusTitle(detail)}
                        </p>
                      </div>
                      {eventsList.length == 1 && (
                        <div className='chevronn'>
                          <img
                            src={
                              commonUtil.getAssetURL() +
                              '/images/chevron_right.svg'
                            }
                            alt=''
                          />
                        </div>
                      )}
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  labels: state.labels.data,
});
export default connect(mapStateToProps)(UserEventsCardList);
